export var Methods;
(function (Methods) {
    Methods["LIGHT"] = "LIGHT";
    Methods["DARK"] = "DARK";
    Methods["TOGGLE"] = "TOGGLE";
    Methods["ALLOW_COOKIE"] = "ALLOWCOOKIE";
    Methods["DENY_COOKIE"] = "DENYCOOKIE";
})(Methods || (Methods = {}));
